<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.52827 0.528514C0.788619 0.268165 1.21073 0.268165 1.47108 0.528514L4.99967 4.05711L8.52827 0.528514C8.78862 0.268165 9.21073 0.268165 9.47108 0.528514C9.73143 0.788864 9.73143 1.21097 9.47108 1.47132L5.47108 5.47132C5.21073 5.73167 4.78862 5.73167 4.52827 5.47132L0.52827 1.47132C0.26792 1.21097 0.26792 0.788864 0.52827 0.528514Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "NextDown",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
